import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponentWithRecords from 'features/FolderManager/components/Questions/components/Form/CustomInputTextComponentWithRecords';
import CustomInputDateComponentWithRecords from 'features/FolderManager/components/Questions/components/Form/CustomInputDateComponentWithRecords';

const styles = {
	fieldRow: {
		width: '100%',
		height: 30,
		border: '1px solid #000',
	},
	radioGroupGender: {},
	freeInputStyle: {
		backgroundColor: 'rgb(239, 238, 238)',
		padding: '5px 10px',
		borderRadius: 4,
	},
};

const DynamicFreeInputField = ({
	name,
	method,
	style,
	setFieldValue,
	setFieldTouched,
	values,
	errors,
	touched,
	prevalidFolders,
	disabled,
}) => {
	switch (method) {
		case 'text':
			return (
				<div style={styles.freeInputStyle}>
					<Field
						type='text'
						name={name}
						records={[]}
						customlabel=''
						component={CustomInputTextComponentWithRecords}
						setFieldValue={setFieldValue}
						freeInput={true}
						placeholder='Autre (préciser)'
						prevalidfolders={prevalidFolders}
						disabled={disabled}
						autoComplete='off'
					/>
				</div>
			);

		case 'number':
			return (
				<div style={styles.freeInputStyle}>
					<Field
						type='number'
						name={name}
						records={[]}
						customlabel=''
						component={CustomInputTextComponentWithRecords}
						setFieldValue={setFieldValue}
						freeInput={true}
						placeholder='Saisir un nombre'
						prevalidfolders={prevalidFolders}
						disabled={disabled}
					/>
				</div>
			);

		case 'date':
			return (
				<div style={styles.freeInputStyle}>
					<Field
						type='date'
						name={name}
						customlabel=''
						component={CustomInputDateComponentWithRecords}
						setFieldValue={setFieldValue}
						records={[]}
						freeInput={true}
						prevalidfolders={prevalidFolders}
						disabled={disabled}
					/>
				</div>
			);
			case 'datetime':
				return (
					<div style={styles.freeInputStyle}>
						<Field
							type='datetime-local'
							name={name}
							customlabel=''
							component={CustomInputDateComponentWithRecords}
							setFieldValue={setFieldValue}
							records={[]}
							freeInput={true}
							prevalidfolders={prevalidFolders}
							disabled={disabled}
						/>
					</div>
				);


		default:
			return <div>Pas de champ</div>;
	}
};

export default DynamicFreeInputField;
